// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1eQXo","linksContainer":"styles_linksContainer__MWomy","link":"styles_link__agaqM","socialMedia":"styles_socialMedia__TB1c5"};